import { render } from "./FPluginPermission.vue?vue&type=template&id=06a432de&scoped=true"
import script from "./FPluginPermission.vue?vue&type=script&lang=js"
export * from "./FPluginPermission.vue?vue&type=script&lang=js"

import "./FPluginPermission.vue?vue&type=style&index=0&id=06a432de&lang=less&scoped=true"
import "./FPluginPermission.vue?vue&type=style&index=1&id=06a432de&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a432de"]])

export default __exports__